import { render, staticRenderFns } from "./TaskHeaderWithLoader.vue?vue&type=template&id=02292edc&scoped=true"
import script from "./TaskHeaderWithLoader.vue?vue&type=script&lang=js"
export * from "./TaskHeaderWithLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02292edc",
  null
  
)

export default component.exports